import { gql } from "@apollo/client";

export const SUBSCRIBE_LIVE = gql`
  mutation SubscribeLive($id: ID! $fbLiveId: String! $page_access_token: String!) {
    subscribeLive(id:$id fbLiveId:$fbLiveId page_access_token:$page_access_token) {
        message
    }
}
`;

export const UNSUBSCRIBE_LIVE = gql`
  mutation UnsubscribeLive($id: ID! $fbLiveId: String! $page_access_token: String!) {
    unsubscribeLive(id:$id fbLiveId:$fbLiveId page_access_token:$page_access_token) {
        message
    }
}
`;

export const UNSUBSCRIBE_LIVE_V2 = gql`
  mutation UnsubscribeLiveV2($fbLiveId: String!) {
    unsubscribeLiveV2(fbLiveId:$fbLiveId) {
        message
    }
}
`;


export const END_LIVE = gql`
  mutation EndLive($id: ID! $fbLiveId: String! $page_access_token: String!) {
    endLive(id:$id fbLiveId:$fbLiveId page_access_token:$page_access_token) {
        message
    }
}
`;

export const END_LIVE_V2 = gql`
  mutation EndLiveV2($id: ID!) {
    endLiveV2(id:$id) {
        message
    }
}
`;

export const SEND_NOTI_TO_CUSTOMER = gql`
  mutation SendNotiToCustomer($shopId: String!, $accessToken: String!, $pageId: String!, $pageName: String!) {
    sendNotiToCustomer(shopId: $shopId, accessToken: $accessToken, pageId: $pageId, pageName: $pageName) {
      allUser
      success
      error
      notSend
    }
  }
`;
